// src/components/SidebarDrawer.tsx
import { Link, useLocation } from 'react-router-dom';
import { useDrawer } from '../contexts/DrawerContext.jsx';
import routeConfig from '../routes/routeConfig';

export default function SidebarDrawer() {
  const { drawerOpen, closeDrawer } = useDrawer();
  const { pathname } = useLocation();

  // Candidate Home and Profile own their drawers; Jobs uses avatar nav — skip global drawer.
  const isCandidateHome =
    pathname === '/candidate/home' || pathname === '/candidate/home/';
  const isCandidateProfile =
    pathname === '/candidate/profile' || pathname.startsWith('/candidate/profile/');
  const isJobsPage =
    pathname === '/jobs' ||
    pathname === '/jobs/' ||
    pathname === '/hv/jobs' ||
    pathname === '/hv/jobs/';

  const isAdminPrivacy = pathname === '/admin/privacy' || pathname.startsWith('/admin/privacy/');
  const isSettingsPrivacy = pathname === '/settings/privacy' || pathname.startsWith('/settings/privacy/');

  if (!drawerOpen || isCandidateHome || isCandidateProfile || isJobsPage || isAdminPrivacy || isSettingsPrivacy) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={closeDrawer}
        style={{
          position:   'fixed',
          inset:      0,
          background: 'var(--overlay-scrim)',
          zIndex:     'var(--z-overlay)',
        }}
      />
      {/* Panel */}
      <nav style={{
        position:     'fixed',
        top:          0,
        left:         0,
        height:       '100vh',
        width:        '240px',
        background:   'var(--bg-surface)',
        borderRight:  '1px solid var(--border-default)',
        zIndex:       'var(--z-modal)',
        padding:      'var(--spacing-4)',
        display:      'flex',
        flexDirection:'column',
        gap:          'var(--spacing-1)',
      }}>
        {routeConfig.map((route: any) => (
          <Link
            key={route.path}
            to={route.path}
            onClick={closeDrawer}
            style={{
              display:       'block',
              padding:       'var(--spacing-3) var(--spacing-4)',
              color:         'var(--text-primary)',
              textDecoration:'none',
              borderRadius:  'var(--radius-md)',
              fontSize:      '14px',
              transition:    'var(--transition-fast)',
            }}
          >
            {route.label}
          </Link>
        ))}
      </nav>
    </>
  );
}
